module.exports = __webpack_public_path__ + "img/Merchant.c36363ac.png";